import { render, staticRenderFns } from "./asModal.vue?vue&type=template&id=1653c852"
import script from "./asModal.vue?vue&type=script&lang=js"
export * from "./asModal.vue?vue&type=script&lang=js"
import style0 from "./asModal.vue?vue&type=style&index=0&id=1653c852&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports